<template>
    <span class="filter-condition" :class="[rule ? 'rule-condition pt-1 pb-1' : '' , conditionText == 'OR' ? 'or-condition' : '']">

        <span class="filter-type">{{ conditionText }}</span>

        <span v-if="!rule" class="filter-type filter-option ml-5" @click="updateCondition">{{  conditionText == 'OR' ? 'AND' : 'OR' }}</span>

    </span>
</template>
<script>
export default {
    name : 'RuleConditions',
    props : {
        rule : {
            type : Boolean,
            default : () => false
        },
        conditionText : {
            type : String,
            default : () => "OR"
        },
        updateCondition :{
            type : Function,
            default : () => null
        }
    }
}
</script>

<style scoped lang="scss">
.filter-condition{
    width:100%;
    padding: 22px 0px;
    position: relative
}

.filter-condition:before{ 
    position: absolute;
    content: '';
    top: -4px;
    left:44px;
    width: 1.5px;
    height: calc(100% + 8px);
    background-color: #d4ecf7;
}
.filter-condition.or-condition:before{
    left: 36px;
}
.rule-condition:before{ 
    top: -30px;
    left: 43px;
    height: calc(100% + 60px);
    background: #545C6C;
}
.rule-condition.or-condition:before{
    left: 36px;
}

.rule-condition .filter-type {
  background: #545C6C;
  color: white;
}
.filter-type{
    width:auto;
    background: #d4ecf7;
    border-radius: 20px;
    padding: 7px 24px;
    font-weight: 600;
    line-height: 24px;
    position: relative;
    text-align: center;
    letter-spacing: 0.55px;
    color: rgba(0, 0, 0, 0.6);
    margin: 20px 0px;    
    font-size: 16px;
    font-family: Montserrat;
    font-style: normal;

}
.filter-option{
    background-color: #E5EAEF;
    color: #fff;
    cursor: pointer;
}
</style>